import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';

Vue.use(Vuetify);

const options = {
  theme: {
    themes: {
      light: {
        primary: '#006e55', // #E53935
      },
    },
    options: { customProperties: true },
  },
};

export default new Vuetify(options);
